import { render, staticRenderFns } from "./OffcanvasMenu.vue?vue&type=template&id=10b41de4&"
import script from "./OffcanvasMenu.vue?vue&type=script&lang=js&"
export * from "./OffcanvasMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports